unit f_modificatrasporti;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  DateUtils, f_selezione, w_edit, un_servermodule, w_label,
  un_telemetria, UnArrayDef, DB, un_user, f_scrivitrasporti;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 trasporti' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare i trasporti';
  msgNessunRecord = 'Nessun trasporto da visualizzare';
  msgCaricamentoInCorso = 'Nessun trasporto da visualizzare...';
//  msgCaricamentoInCorso = 'Caricamento trasporti in corso...';

type
  { TFrmModificaTrasporti }

  TFrmModificaTrasporti = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate :String;
    dt1str, dt2str :String;
    function DateOk:Boolean;
    procedure RefreshTrasporti; async;
    procedure QryTrasportiOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
  published
    procedure tab1_rowclick; async;
    procedure filtro_change;
    procedure filtro_input;
    procedure impostadate;
    procedure data1_change;
    procedure data2_change;
    data1 : TJSHTMLInputElement;
    data2 : TJSHTMLInputElement;
    filtro: TWEdit;
    edit2: TJSHTMLInputElement;
    idriepilogo: TJSHTMLInputElement;
    pnltab1: TJSHTMLElement;
    QryTrasporti: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
  end;

implementation

{$R *.html}

{ TFrmModificaTrasporti }

procedure TFrmModificaTrasporti.AfterRender;
begin

  QryTrasporti.OnFilterRecord := @QryTrasportiOnFilterRecord;

  filtro.placeholder := 'Ricerca trasporti...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';

  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';

  impostadate;

  RefreshTrasporti;

end;


procedure TFrmModificaTrasporti.QryTrasportiOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;



procedure TFrmModificaTrasporti.SetLabel(lbl:TWLabel;value:String);
begin
  lbl.Visible :=   value <> '' ;
  lbl.labelbody.innerHTML := value;
end;

procedure TFrmModificaTrasporti.ImpostaVisibilita(visibilita: TVisibilita);
begin
  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible :=  visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];
end;

procedure TFrmModificaTrasporti.RefreshTrasporti;
begin

  if not DateOk then
  begin
    ImpostaVisibilita(visDateErrate);
    exit;
  end;
  ImpostaVisibilita(visCaricamentoInCorso);
  QryTrasporti.Close;
  QryTrasporti.SQL.Text:= ' select idtrasporto, dtdata as data, horapartenza as orap, horaarrivo as entrole, '
                      + ' dsautista as autista, dsaccompagnatore as accomp, dsautomezzo as mezzo, '
                      + ' dstiporichiesta as rich, dsfruitore as partenza, dsindirizzopartenza as indpartenza, '
                      + ' dsfruitore2 as arrivo, dsindirizzoarrivo as indarrivo, dstelefono as telef, '
                      + ' dsnote as note '
                      + ' from ta_trasporti '
                      + ' where idsocieta = ''DON001'' '
                      + ' and ' + whereDate;
  QryTrasporti.SQL.Text := QryTrasporti.SQL.Text + ' order by dtdata, dsautista, horapartenza ';
  AWait(QryTrasporti.Open);

  QryTrasporti.FieldByName('IDTRASPORTO').Visible:= false;

  RefreshFiltro;
end;

procedure TFrmModificaTrasporti.RefreshFiltro;
begin
  QryTrasporti.Filtered:= filtro.value.Trim <> '';
  QryTrasporti.First;
  tab1.RenderDataSet(QryTrasporti);

  if QryTrasporti.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryTrasporti.RecordCount = limiteRecord  then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);
end;

procedure TFrmModificaTrasporti.filtro_change;
begin
  RefreshFiltro;
end;

procedure TFrmModificaTrasporti.filtro_input;
begin
  RefreshFiltro;
end;

procedure TFrmModificaTrasporti.impostadate;
begin
  data1.value:=FormatDateTime('yyyy-mm-dd',Date);
  data2.value:=FormatDateTime('yyyy-mm-dd',Date);
end;

procedure TFrmModificaTrasporti.tab1_rowclick;
var
  instance: TFrmScriviTrasporti;
begin
  instance := TFrmScriviTrasporti.Create();
  instance.idtrasporto := QryTrasporti.FieldByName('idtrasporto').AsInteger;
  Await(instance.show);
  RefreshTrasporti;
end;

procedure TFrmModificaTrasporti.data1_change;
begin

  window.localStorage[ClassName+'_data1'] := data1.value;

  RefreshTrasporti;

end;

procedure TFrmModificaTrasporti.data2_change;
begin

  window.localStorage[ClassName+'_data2'] := data2.value;

  RefreshTrasporti;

end;

function TFrmModificaTrasporti.DateOk: Boolean;
var
  dt1, dt2: TDateTime;
begin

  Result :=  false;

  if (data1.value = '') or (data2.value = '')
    or (data1.value > data2.value) then
  begin
    SetLabel(labelTop,msgDateErrate);
    SetLabel(labelBottom,'');
    exit;
  end;

  Result :=  true;

  dt1 := ScanDateTime('yyyy-MM-dd',data1.value);
  dt2 := ScanDateTime('yyyy-MM-dd',data2.value) ;
  dt2 := IncDay(dt2);

// questo formato date serve per la query
  dt1str := FormatDateTime('dd.MM.yyyy',dt1);
  dt2str := FormatDateTime('dd.MM.yyyy',dt2);

  whereDate := ' dtdata >= ''' + dt1str + ''''
    + ' and dtdata < ''' + dt2str + '''';

// questo formato di date serve alla stampa
  dt1str := FormatDateTime('dd/MM/yyyy',dt1) + ' 00:00:00';
  dt2str := FormatDateTime('dd/MM/yyyy',dt2) + ' 00:00:00';

end;

initialization
  RegisterWeb(TFrmModificaTrasporti);

end.

